@if (!useLocalFormat()) {
  <p class="mb-2 font-base text-xs font-normal text-neutral-500">
    {{ 'PHONE_INPUT.HELP_WITH_DIAL_CODE' | translate: { example: examplePhoneNumber() } }}
  </p>
} @else if (helpTranslateKey()) {
  <p class="mb-2 font-base text-xs font-normal text-neutral-500">
    {{ helpTranslateKey() | translate }}
  </p>
}

<div class="kiosk-phone-input-wrapper">
  <!-- Only show flag container if not using local format -->
  @if (!useLocalFormat()) {
    <div
      class="flag-container"
      (click)="toggleCountriesList($event)"
    >
      <div class="selected-flag">
        <div class="flag">
          <img
            [src]="selectedIso() | appFn: getFlagIcon"
            [alt]="selectedIso() + ' flag'"
            class="flag-img"
          />
        </div>
        <div class="arrow"></div>
      </div>
      <!-- Country List Container -->
      @if (listOpen()) {
        <div class="country-list-container">
          <!-- Basic country list -->
          @if (!showExtendedList()) {
            <div class="country-list">
              @for (country of filteredCountries; track trackByIso($index, country)) {
                <div
                  class="country"
                  (click)="selectCountry(country.iso2); $event.stopPropagation()"
                >
                  <div class="country-content">
                    <div class="flag-wrapper">
                      <div class="flag">
                        <img
                          [src]="country.iso2 | appFn: getFlagIcon"
                          [alt]="country.iso2 + ' flag'"
                          class="flag-img"
                        />
                      </div>
                    </div>
                    <div class="country-info">
                      <div class="country-name">{{ country.name }}</div>
                    </div>
                    <div class="dial-code">+{{ country.dialCode }}</div>
                  </div>
                </div>
              }
              <div
                class="country show-more"
                (click)="showAllCountries(); $event.stopPropagation()"
              >
                <div class="country-name">{{ 'PHONE_INPUT.SHOW_MORE_COUNTRIES' | translate }}</div>
              </div>
            </div>
          }
          <!-- Extended country list with search -->
          @if (showExtendedList()) {
            <div class="extended-country-list">
              <div class="search-header">
                <button
                  class="back-button"
                  (click)="backToShortList(); $event.stopPropagation()"
                >
                  {{ 'PHONE_INPUT.BACK' | translate }}
                </button>
              </div>
              <div class="countries-container">
                @for (country of filteredAllCountries; track trackByIso($index, country)) {
                  <div
                    class="country"
                    (click)="selectCountry(country.iso2); $event.stopPropagation()"
                  >
                    <div class="country-content">
                      <div class="flag-wrapper">
                        <div class="flag">
                          <img
                            [src]="country.iso2 | appFn: getFlagIcon"
                            [alt]="country.iso2 + ' flag'"
                            class="flag-img"
                          />
                        </div>
                      </div>
                      <div class="country-info">
                        <div class="country-name">{{ country.name }}</div>
                      </div>
                      <div class="dial-code">+{{ country.dialCode }}</div>
                    </div>
                  </div>
                }
                @if (filteredAllCountries.length === 0) {
                  <div class="no-results">
                    {{ 'PHONE_INPUT.NO_RESULTS' | translate }}
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  <input
    type="tel"
    name="phone"
    class="phone-input"
    [class.full-width]="useLocalFormat()"
    [ngModel]="displayedPhone()"
    (ngModelChange)="onChangePhone($event)"
    [placeholder]="
      useLocalFormat() && selectedIso() === 'fr'
        ? ('PHONE_INPUT.PLACEHOLDER_WITH_EXAMPLE' | translate)
        : ('PHONE_INPUT.PLACEHOLDER' | translate)
    "
    autocomplete="tel"
  />
</div>
